var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"logo-card",staticStyle:{"min-height":"80vh"}},[_c('div',{staticClass:"bg-logo"}),_c('h1',{staticClass:"text-primary welcome-text"},[_vm._v("به پنل ادمین ورگل خوش آمدید.")])])}
var staticRenderFns = []

export { render, staticRenderFns }